import { Phone, Mail, MapPin, Clock, Instagram, Facebook } from "lucide-react";
import { Reveal } from "../Reveal";
import { CONTACT, NAV_LINKS } from "../../data/content";
import { scrollToId } from "../../lib/scroll";

export const Footer = () => {
  return (
    <footer
      id="footer"
      data-testid="footer-section"
      className="relative bg-[#09090b] pt-24 pb-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20">
          {/* Left: brand + contact */}
          <div>
            <Reveal>
              <img src="/mpm/logo.png" alt="Mad Props Marine" className="h-16 w-auto" />
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-7 text-white/60 font-light text-lg max-w-md leading-relaxed">
                No matter the time or place, Mad Props Marine guarantees to have
                your back in any marine situation.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-5 font-display font-bold text-[#e85d04] text-xl tracking-tight">
                {CONTACT.tagline}
              </p>
            </Reveal>

            <div className="mt-10 grid sm:grid-cols-2 gap-6">
              <div>
                <p className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-3">Contact</p>
                <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 text-white/80 hover:text-[#e85d04] transition-colors mb-2">
                  <Phone size={17} /> {CONTACT.phone}
                </a>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-white/80 hover:text-[#e85d04] transition-colors">
                  <Mail size={17} /> {CONTACT.email}
                </a>
              </div>
              <div>
                <p className="text-xs font-bold tracking-[0.2em] uppercase text-white/40 mb-3">Hours</p>
                <div className="flex items-start gap-3 text-white/80 mb-2">
                  <Clock size={17} className="mt-0.5" />
                  <span>Open 24 hours<br /><span className="text-white/50 text-sm">7 days · 365 days</span></span>
                </div>
                <div className="flex items-center gap-3 text-white/80">
                  <MapPin size={17} /> {CONTACT.location}
                </div>
              </div>
            </div>

            <div className="mt-10 flex items-center gap-3">
              <a
                data-testid="footer-instagram"
                href="https://www.instagram.com/madpropsmarine/"
                target="_blank"
                rel="noopener noreferrer"
                className="h-11 w-11 rounded-full border border-white/15 hover:border-[#e85d04] hover:bg-[#e85d04] flex items-center justify-center text-white transition-all duration-300"
              >
                <Instagram size={19} />
              </a>
              <a
                data-testid="footer-facebook"
                href="https://www.madpropsmarine.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="h-11 w-11 rounded-full border border-white/15 hover:border-[#e85d04] hover:bg-[#e85d04] flex items-center justify-center text-white transition-all duration-300"
              >
                <Facebook size={19} />
              </a>
            </div>
          </div>

          {/* Right: map + nav */}
          <div>
            <Reveal delay={0.1}>
              <div className="rounded-3xl overflow-hidden border border-white/10 h-72 lg:h-80">
                <iframe
                  title="Mad Props Marine — Ladner, BC"
                  data-testid="footer-map"
                  src="https://www.google.com/maps?q=Ladner,%20Delta,%20BC&output=embed"
                  className="w-full h-full grayscale contrast-125"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3">
                {NAV_LINKS.map((l) => (
                  <button
                    key={l.id}
                    data-testid={`footer-nav-${l.id}`}
                    onClick={() => scrollToId(l.id)}
                    className="text-white/60 hover:text-white text-sm font-medium transition-colors"
                  >
                    {l.label}
                  </button>
                ))}
              </div>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} Mad Props Marine · Ladner, BC
          </p>
          <p className="text-white/30 text-xs tracking-wide">
            Website Concept 2026 — a modern West Coast brand experience.
          </p>
        </div>
      </div>
    </footer>
  );
};
